<template>
  <div>
    <edit-form />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'system-parameter-detail',
  components: {
    EditForm,
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
}
</script>
